import { Typography, Container, Divider, Box } from "@mui/material";
import Page from "../component/Page";
import { DataRequestLink } from "../component/Utils/utils";

export default function DataRequestPolicy() {
  return (
    <Page>
      <Container sx={{ py: 10 }}>
        <Typography variant="h3" >Data Request Policy</Typography>
        <Typography gutterBottom>Kentucky Mesonet data are free to state government, educational establishments for pedagogy and research, and the general public for personal use. A cost-recovery fee may be charged for commercial data requests.
          Data fees for access to Kentucky Mesonet data by media are waived provided the Mesonet is acknowledged. For television, the logo must be displayed along with verbal mention of “The Kentucky Mesonet”. For radio, the following acknowledgement must be read on air: “Weather data are provided by the Kentucky Mesonet at WKU.” Newspapers must include the Kentucky Mesonet logo and a link to the Mesonet webpage: www.kymesonet.org/.
        </Typography>
        <Typography gutterBottom>
          Kentucky Mesonet data may be requested from the data request page: {<a target="_blank" href={DataRequestLink}>{DataRequestLink}</a>}.
        </Typography>
        <Typography>
          For more information, please contact the Kentucky Mesonet Director, Dr. Jerry Brotzge, at jerald.brotzge@wku.edu.
        </Typography>
      </Container>

    </Page>
  );
}
